import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useAppointmentStore } from "src/stores/useAppointmentStore";

const AppointmentConfirmationDialog = ({
  open,
  onClose,
  doctor,
  slot,
  reason,
}) => {
  const { createAppointment, setToastOpen } = useAppointmentStore();

  const handleConfirm = () => {
    const appointmentData = {
      doctorId: doctor.id,
      doctorName: doctor.firstname,
      patientName: JSON.parse(sessionStorage.getItem("user")).firstname,
      slot: `${slot.start} - ${slot.end}`,
      slotDate: slot.date,
      reason: reason,
      patientId: JSON.parse(sessionStorage.getItem("user")).pp_id,
    };
    createAppointment(appointmentData);
    setToastOpen(true);
    onClose();
  };
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Appointment</DialogTitle>
      <DialogContent>
        <Typography>Doctor: {doctor?.firstname}</Typography>
        <Typography>Slot: {`${slot?.start} - ${slot?.end}`}</Typography>
        <Typography>Reason: {reason}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppointmentConfirmationDialog;
